const {
    LOCAL_ENVIRONMENT,
    DEV_ENVIRONMENT,
    QA_ENVIRONMENT,
    STG_ENVIRONMENT,
    PROD_ENVIRONMENT,
    PROD_HIDDEN_ENVIRONMENT,
} = require('constants/index');

const baseEnvironmentConfigObject = require('../../environment_config/base.json');
const { remove } = require('utilities/helperFunctions');
let concreteEnvironmentConfigObject;

switch (__ENV__) {
    case LOCAL_ENVIRONMENT:
        concreteEnvironmentConfigObject = require('../../environment_config/local.json');
        break;
    case DEV_ENVIRONMENT:
        concreteEnvironmentConfigObject = require('../../environment_config/dev.json');
        break;
    case QA_ENVIRONMENT:
        concreteEnvironmentConfigObject = require('../../environment_config/qa.json');
        break;
    case STG_ENVIRONMENT:
        concreteEnvironmentConfigObject = require('../../environment_config/stg.json');
        break;
    case PROD_HIDDEN_ENVIRONMENT:
        concreteEnvironmentConfigObject = require('../../environment_config/ocu.json');
        break;
    case PROD_ENVIRONMENT:
        concreteEnvironmentConfigObject = require('../../environment_config/pro.json');
        break;
}

function buildEndpoints(baseEndpoints, redefinedEndpoints) {
    redefinedEndpoints.forEach(function (concreteEntry) {
        remove(baseEndpoints, function (baseEntry) {
            return baseEntry.name === concreteEntry.name;
        });
    });

    return baseEndpoints.concat(redefinedEndpoints);
}

const config = {
    services: {
        hosts: Object.assign(baseEnvironmentConfigObject.hosts, concreteEnvironmentConfigObject.hosts),
        endpoints: buildEndpoints(baseEnvironmentConfigObject.endpoints, concreteEnvironmentConfigObject.endpoints),
        mocked: !!concreteEnvironmentConfigObject.mockData.enabled,
    },
};

if (config.services.mocked) {
    const mockEndpoints = buildEndpoints(
        baseEnvironmentConfigObject.mockData.endpoints,
        concreteEnvironmentConfigObject.mockData.endpoints
    );

    config.services.endpoints = buildEndpoints(config.services.endpoints, mockEndpoints);
}

module.exports = config;
